<script setup lang="ts">
import { Head } from "@inertiajs/vue3";

import { Button } from "@/components/ui/button/index";
import SettingsLayout from "@/layouts/settings/layout";

defineOptions({ inheritAttrs: false });
const setAppearance = (mode: "light" | "dark" | "system") => {
  if (mode === "system") {
    localStorage.removeItem("appearance");
  } else {
    localStorage.setItem("appearance", mode);
  }

  window.location.reload();
};
</script>

<template>
  <Head title="Appearance settings" />

  <main
    class="relative flex h-full min-h-0 w-full flex-col gap-3 bg-muted/50 p-3"
  >
    <SettingsLayout
      current="appearance"
      title="Appearance settings"
      description="Pick your preferred appearance mode."
    >
      <div class="flex flex-wrap gap-2">
        <Button type="button" variant="outline" @click="setAppearance('light')">
          Light
        </Button>
        <Button type="button" variant="outline" @click="setAppearance('dark')">
          Dark
        </Button>
        <Button
          type="button"
          variant="outline"
          @click="setAppearance('system')"
        >
          System
        </Button>
      </div>
    </SettingsLayout>
  </main>
</template>
